export const id = {
    translation: {
        b: {
            cancel: 'Batalkan',
            confirm: 'Konfirmasi',
            send: 'Kirim',
            done: 'Selesai',
            close: 'Tutup',
            clear: 'Bersihkan',
            copy_link: 'Salin tautan',
            export: 'Ekspor',
            delete: 'Hapus',
            delete_confirm: 'Konfirmasi penghapusan',
            duplicate: 'Duplikat',
            share: 'Bagikan',
            sign_in: 'Masuk',
            sign_up: 'Daftar',
            email_address: 'Alamat email',
            yes: 'Ya',
            no: 'Tidak'
        },
        m_languages: {
            title: 'Bahasa',
            subtitle: 'Pilih bahasa'
        },
        m_feedback: {
            feature: {
                name: 'Permintaan fitur',
                desc: 'Ada fitur yang Anda butuhkan belum tersedia? Beri tahu kami — ide Anda penting'
            },
            feedback: {
                name: 'Umpan balik',
                desc: 'Umpan balik Anda sangat berarti bagi kami — tinggalkan catatan singkat'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Terima kasih atas saran Anda!',
                desc: 'Kami sangat menghargai waktu yang Anda luangkan untuk berbagi pemikiran — hal ini membantu kami menjadi lebih baik.'
            },
            feedback: {
                name: 'Terima kasih atas umpan balik Anda!',
                desc: 'Kami sangat menghargai waktu yang Anda luangkan untuk berbagi pemikiran — hal ini membantu kami menjadi lebih baik.'
            }
        },
        m_diagram_details: {
            name_place: 'Masukkan nama proyek',
            desc_place: 'Masukkan deskripsi proyek'
        },
        m_quick_share: {
            title: 'Berbagi cepat',
            subtitle: '(Lewat tautan)'
        },
        m_export_img: {
            title: 'Ekspor gambar'
        },
        m_export_code: {
            title: 'Ekspor kode {{db_engine}}',
            download_file: 'Unduh file',
            copy_code: 'Salin kode'
        },
        m_sign_in_remind: {
            title: 'Terima kasih telah mencoba aplikasi ini',
            subtitle: 'Masuk atau daftar untuk menaikkan jumlah maksimum tabel, menyimpan diagram, dan membuka lebih banyak fitur.'
        },
        m_sign_in_restrict: {
            title: 'Masuk untuk melakukan lebih banyak di aplikasi',
            subtitle: 'Masuk atau daftar untuk meningkatkan batas tabel, menyimpan diagram, dan membuka lebih banyak fitur.'
        },
        m_new_diagram: {
            title: 'Diagram baru',
            subtitle: 'Pilih mesin basis data',
            open_diagram: 'Buka diagram'
        },
        m_keyboard_shortcuts: {
            title: 'Pintasan keyboard',
            ctrl_left: {
                title1: 'Kontrol',
                title2: '(Kiri)',
                items: {
                    mouse_sel: 'Seleksi mouse / Mode tangan',
                    table: 'Tabel',
                    line: 'Garis',
                    area: 'Area',
                    note: 'Catatan',
                    comment: 'Komentar',
                    pen: 'Pena',
                    undo: 'Urungkan',
                    redo: 'Ulangi'
                }
            },
            ctrl_top_left: {
                title1: 'Kontrol',
                title2: '(Kiri atas)',
                items: {
                    export_img: 'Ekspor gambar',
                    search: 'Cari',
                    editor_panel: 'Panel editor'
                }
            },
            ctrl_bottom_right: {
                title1: 'Kontrol',
                title2: '(Kanan bawah)',
                items: {
                    minimap: 'Minimap',
                    zoom_in: 'Perbesar',
                    zoom_out: 'Perkecil',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu konteks',
                title2: '(Tabel)',
                items: {
                    dupl_tab: 'Duplikat tabel',
                    del_tab: 'Hapus tabel'
                }
            },
            ctx_del_tab: {
                title1: 'Menu konteks',
                title2: '(Hapus tabel)',
                items: {
                    yes: 'Ya',
                    no: 'Tidak'
                }
            },
            ctx_tab_col: {
                title1: 'Menu konteks',
                title2: '(Kolom tabel)',
                items: {
                    add_col_below: 'Tambah kolom di bawah',
                    focus_col_above: 'Fokus ke kolom di atas',
                    focus_col_below: 'Fokus ke kolom di bawah',
                    move_col_up: 'Pindahkan kolom ke atas',
                    move_col_down: 'Pindahkan kolom ke bawah',
                    dupl_col: 'Duplikat kolom',
                    del_col: 'Hapus kolom'
                }
            },
            ctx_line: {
                title1: 'Menu konteks',
                title2: '(Garis)',
                items: {
                    del_line: 'Hapus garis'
                }
            },
            ctx_area: {
                title1: 'Menu konteks',
                title2: '(Area)',
                items: {
                    dupl_area: 'Duplikat area',
                    del_area: 'Hapus area'
                }
            },
            ctx_multi: {
                title1: 'Menu konteks',
                title2: '(Multiseleksi)',
                items: {
                    select_all: 'Pilih semua elemen',
                    create_area_for_select_els: 'Buat area untuk elemen terpilih',
                    dupl_select_els: 'Duplikat elemen terpilih',
                    del_select_els: 'Hapus elemen terpilih'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Seleksi mouse',
                table: 'Tabel',
                line: 'Garis',
                area: 'Area',
                note: 'Catatan (segera)',
                comment: 'Komentar (segera)',
                pen: 'Pena',
                undo: 'Urungkan',
                redo: 'Ulangi'
            },
            ctrl_top_left: {
                logo: 'Catatan: Ini adalah sandbox (area uji)',
                name: 'Informasi diagram',
                editor: 'Editor (segera)',
                search: 'Pencarian (segera)',
                export: 'Opsi ekspor',
                view_mode: 'Mode tampilan',
                zoom_to_fit: 'Sesuaikan ke layar'
            },
            ctrl_top_right: {
                feature_req: 'Permintaan fitur',
                sign_in: 'Masuk',
                quick_share: 'Berbagi cepat'
            },
            ctrl_bottom_right: {
                full_screen: 'Layar penuh',
                minimap: 'Minimap',
                zoom_out: 'Perkecil',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Perbesar',
                info: 'Informasi & sumber daya'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Bawaan',
                        blue: 'Biru',
                        green: 'Hijau',
                        red: 'Merah',
                        purple: 'Ungu',
                        violet: 'Violet'
                    },
                    borders: {
                        none: 'Tidak ada',
                        solid: 'Solid',
                        dashed: 'Putus-putus',
                        dotted: 'Titik-titik'
                    },
                    color: 'Warna',
                    border: 'Garis tepi',
                    description: 'Deskripsi',
                    description_table_place: 'Deskripsi tabel',
                    description_column_place: 'Deskripsi kolom',
                    description_line_place: 'Deskripsi garis',
                    description_note_place: 'Deskripsi catatan',
                    description_area_place: 'Deskripsi area',
                    description_pen_place: 'Deskripsi pensil',
                    hide_menu: 'Sembunyikan menu',
                    show_menu: 'Tampilkan menu'
                },
                tab_col: {
                    add_col_below: 'Tambah kolom di bawah',
                    add_col_above: 'Tambah kolom di atas',
                    key: 'Key (Kunci)',
                    keys: {
                        none: 'Tidak ada',
                        pk: 'PK (Kunci Primer)',
                        fk: 'FK (Kunci Asing)'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Tidak ada',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Pindahkan kolom ke bawah',
                    move_col_up: 'Pindahkan kolom ke atas',
                    more_functions: 'Fungsi lainnya'
                },
                line: {
                    change_connects: 'Ubah konektor',
                    connects: {
                        empty: 'Kosong',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'Saring elemen'
                },
                multi: {
                    filter: 'Saring seleksi',
                    create_area: 'Buat area'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Penuh',
            keys_only: 'Hanya key',
            names_only: 'Hanya nama'
        },
        dropdown_ctrl_export: {
            export_img: 'Ekspor gambar',
            export_code: 'Ekspor kode SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Masuk',
            new_project: 'Proyek baru',
            keyboard_shortcuts: 'Pintasan keyboard',
            languages: 'Bahasa'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Umpan balik',
            keyboard_shortcuts: 'Pintasan keyboard',
            languages: 'Bahasa',
            homepage: 'Beranda'
        },
        n: {
            default: 'Memuat…',
            file_ready_to_download: 'File siap diunduh',
            code_copied: 'Kode telah disalin',
            link_copied: 'Tautan telah disalin',
            please_enter_message: 'Silakan masukkan pesan',
            invalid_email: 'Alamat email tidak valid',
            something_wrong_contact: 'Terjadi kesalahan. Silakan muat ulang halaman atau hubungi kami.',
            something_wrong: 'Terjadi kesalahan. Silakan muat ulang halaman.',
            sending: 'Mengirim…',
            request_sent: 'Permintaan telah dikirim. Terima kasih!'
        }
    }
};

export const idMeta = {
    lang_origin: 'Bahasa Indonesia',
    lang_eng: 'Indonesian',
    lang_code: 'id',
};
